
export default function Navigation() {

	let container,
		dropdowns,
		toggle,
		body,
		headerLogo,
		toggled = false,
		scrolled = false,
		scrollTimeout,
		wrapper;

	body = document.body;
	container = document.querySelector('.mainNav');
	wrapper = document.querySelector('.allWrapper');

	if ( ! container ) {
		return;
	}

	toggle = document.querySelector('.mainNav-menuToggle');


	toggle.addEventListener('touchend', toggleF, false);
	wrapper.addEventListener('touchend', toggleF,false);


	if (!window.matchMedia("(min-width: 1000px)").matches) {

		headerLogo = document.querySelector('.header-logo');

		if( window.scrollY ) {
			scrolled = true;
			headerLogo.classList.remove('header-logo_top');
		}

		window.addEventListener('scroll', function () {
			if( window.scrollY ) {
				if(scrolled == false) {
					scrolled = true;
					headerLogo.classList.remove('header-logo_top');
				}
			}else {
				if(scrolled == true) {
					scrolled = false;
					headerLogo.classList.add('header-logo_top');
				}
			}

		});

	}

	function toggleF( e ) {

		//console.log(this == wrapper);

		if (this == wrapper && !wrapper.classList.contains('allWrapper_slideout') ){
			return;
		}

		if (!window.matchMedia("(min-width: 1000px)").matches) {
			toggled = !toggled;
			container.classList.toggle('mainNav_active');
			toggle.classList.toggle('mainNav-menuToggle_active');
			body.classList.toggle('lockScroll');
			wrapper.classList.toggle('allWrapper_slideout');

			if( !scrolled ) {
				if( toggled ) {
					headerLogo.classList.remove('header-logo_top');
				}else {
					headerLogo.classList.add('header-logo_top');
				}
			}


		}
	}


	if (!window.matchMedia("(min-width: 1000px)").matches) {
		dropdowns = [ ... container.getElementsByClassName('menu-item-has-children') ];

		if( dropdowns.length ) {
			dropdowns.forEach( ( el ) => { 
				el.addEventListener('click', function () {

					let dropdownList = this.querySelector('ul');

					dropdowns.forEach( ( el ) => {
						if(el != this) {
							el.classList.remove( 'toggled' );
							el.querySelector('ul').style = '';
						}

					});

					if( !this.classList.contains( 'toggled') ) {
						dropdownList.style.maxHeight = dropdownList.scrollHeight+'px';
					} else {
						this.querySelector('ul').style = '';
					}
					this.classList.toggle( 'toggled' );

				});
			});
		}
	}


}
